<ng-container *transloco="let t">
  @if (product()) {
    <section
      class="content-product"
      [ngClass]="{ 'with-presentations': withPresentations(), 'cart-disabled': isCartDisabled() }"
    >
      <h1 class="ui-title">
        <div class="title-content">
          <pxw-icon icon="back" (click)="back()"></pxw-icon>
          <div>
            @if (displaySku() && product().sku) {
              <p class="product-sku">{{ product().sku }}</p>
            }
            <span class="product-title">{{
              product() | propInSelectedLanguage: 'name' : selectedLanguage() : true
            }}</span>
          </div>
        </div>
        @if (displayShareButton()) {
          <app-share-button
            [url]="productShareUrl()"
            [shareText]="t('product.shareText')"
            [buttonColor]="'theme2-contrast'"
          />
        }
      </h1>

      <form
        class="product-wrapper"
        id="productForm"
        #productForm="ngForm"
        tabindex="0"
        (keydown.enter)="$event.preventDefault()"
        (ngSubmit)="addToCart($event, productForm, product())"
      >
        <pxw-product-details
          [product]="product()"
          [productType]="productType()"
          [catalogConfiguration]="establishment().catalogConfiguration"
          [selectedLanguage]="selectedLanguage()"
          [displaySku]="displaySku()"
          [cartItemId]="cartItemId()"
          [isFormSubmitted]="isFormSubmitted()"
          [displayProductPriceWithoutTaxes]="displayProductPriceWithoutTaxes()"
          [promotions]="productPromotions()"
          [purchaseOptions]="purchaseOptions()"
          [(productObservations)]="productObservations"
          [(selectedOptions)]="selectedOptions"
          [(selectedPresentationOption)]="selectedPresentationOption"
          (selectedOptionsChange)="onStockSelectionChanged()"
          (selectedPresentationOptionChange)="onStockSelectionChanged()"
        />
        @if (product().tags?.length > 0) {
          <div class="product-tags">
            <hr class="ui-separator ui-separator--sm" />
            <p class="product-tags__title">{{ t('product.relatedProductsTitle') }}</p>
            <div class="product-tags__list">
              @for (
                current of product().linkedProductTagIds
                  | pxwProductTagsWithQuantities: activeProducts();
                track current.productTag.id
              ) {
                <pxw-product-tag
                  class="ui-clickable"
                  [tag]="current.productTag.tag"
                  [color]="current.productTag.color"
                  [count]="current.count"
                  size="sm"
                  [routerLink]="['/productos-relacionados']"
                  [queryParams]="{ t: current.productTag.id }"
                />
              }
            </div>
          </div>
        }
      </form>

      <div class="product-footer">
        @let isCategoryAvailable = category() | pxwIsCategoryAvailable$ | async;

        @if (isCartDisabled()) {
          <pxw-alert type="warning" size="sm" (click)="displayWorkingHours($event)">
            {{ t('global.cartDisabledWhileClosed') }}
          </pxw-alert>
        } @else if (!isCategoryAvailable) {
          <pxw-alert
            type="warning"
            size="sm"
            (click)="categoryAvailabilityDialog.open(category())"
            class="not-available-wrapper"
          >
            <pxw-icon icon="clock" />
            <div class="not-available-content">
              {{ t('categoryAvailability.productNotAvailable') }}
              <pxw-button color="yellow" size="sm" [rounded]="true">{{
                t('categoryAvailability.checkSchedule')
              }}</pxw-button>
            </div>
          </pxw-alert>
          <pxw-category-availability-dialog #categoryAvailabilityDialog />
        } @else if (isWithoutStock()) {
          <pxw-alert type="info" size="sm">{{ t('product.withoutStock') }}</pxw-alert>
        } @else {
          <pxw-product-quantity-selector
            formId="productForm"
            [category]="category()"
            [product]="product()"
            [selectedPresentationOption]="selectedPresentationOption()"
            [selectedOptions]="selectedOptions()"
            [maxQuantity]="maxQuantity()"
            [hasStockIssues]="hasStockIssues()"
            [buttonText]="editMode() ? t('product.update') : t('product.add')"
            [(productQuantity)]="productQuantity"
            (productQuantityChange)="onStockSelectionChanged()"
          />
        }
      </div>
    </section>
  } @else {
    <div class="ui-loader">
      <pxw-icon icon="loading" [spin]="true"></pxw-icon>
    </div>
  }
</ng-container>
